var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoopIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.543 17.3302L14.8672 12.6549C15.9305 11.0765 16.4551 9.10448 16.1742 7.00315C15.6953 3.42892 12.7656 0.520244 9.18749 0.0672841C3.86755 -0.605808 -0.605907 3.86715 0.0672989 9.18651C0.520426 12.7658 3.42981 15.6975 7.00482 16.174C9.10639 16.4548 11.0791 15.9305 12.6572 14.8672L17.333 19.5424C17.9431 20.1525 18.9326 20.1525 19.5428 19.5424C20.1524 18.9316 20.1524 17.9395 19.543 17.3302ZM3.08981 8.12412C3.08981 5.36738 5.33279 3.12465 8.08983 3.12465C10.8469 3.12465 13.0898 5.36738 13.0898 8.12412C13.0898 10.8809 10.8469 13.1236 8.08983 13.1236C5.33279 13.1236 3.08981 10.8816 3.08981 8.12412Z",
    fill: "#343434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopIco);
export default __webpack_public_path__ + "static/media/loop_ico.5f66c760a36fd219701b4e91657d5cca.svg";
export { ForwardRef as ReactComponent };